import React, { useState } from 'react';
import { Formik } from 'formik';
import { EditPropertySchemaGenerator } from './EditPropertyAddressSchema';
import { SwitchDialogWindows } from '../../../components';
import { SuccessMessage } from './SuccessMessage';
import { ErrorTitle } from './ErrorTitle';
import { EditPropertyAddressModal } from './EditPropertyAddressModal';
import { IPropertyAddress } from '../../interfaces/IPropertyAddress';

export interface IEditPropertyAddressFormProps {
  actions: {
    doSubmit: (x: IPropertyAddress, y: boolean) => Promise<{ message: string }>;
    onClose: () => void;
  };
  propertyAddress: IPropertyAddress;
}

export const EditPropertyAddressForm: React.FC<IEditPropertyAddressFormProps> = ({
  propertyAddress,
  actions: { doSubmit, onClose },
}) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  return (
    <Formik
      validationSchema={EditPropertySchemaGenerator()}
      initialValues={{
        ...propertyAddress,
        skipAddressValidation: false,
      }}
      onSubmit={async (values) => {
        try {
          await doSubmit(values, values.skipAddressValidation);
        } catch (error: any) {
          setErrorMessage(error.response.data);
        }
        setIsCompleted(true);
      }}
    >
      {({ isSubmitting, isValid, dirty, errors, values }) => (
        <SwitchDialogWindows
          isLoading={isSubmitting}
          loadingTitle={`Working...`}
          isCompleted={isCompleted}
          isError={!!errorMessage}
          successTitle={``}
          successMessage={SuccessMessage}
          errorTitle={<ErrorTitle />}
          errorMessage={errorMessage}
          onCloseClick={onClose}
        >
          <EditPropertyAddressModal
            disableSubmitButton={!isValid && !isSubmitting && !dirty}
            onClose={onClose}
            skipAddressValidation={values.skipAddressValidation}
          />
        </SwitchDialogWindows>
      )}
    </Formik>
  );
};
